import { ExpandMoreOutlined } from '@mui/icons-material';
import {
  AccordionSummary,
  Box,
  ListSubheader,
  AccordionDetails,
} from '@mui/material';

import { useState } from 'react';

import { useQuery } from '@apollo/client/react';

import { Or2Accordion } from '@/components/Surface/Or2Accordion';

import { extractConnectionProps } from '@/utils/queries/queryExtracts';

import { POST_LIMIT } from '@/modules/group/noticeboard/PostCollection';

import { graphql } from '@/gql';
import { MultiGroupPinnedPostCollection } from '@/modules/post/MultiGroupPinnedPostCollection';

export const SERVICE_GROUPS_PINNED_POSTS_QUERY = graphql(`
  query ServiceGroupsPinnedPostsQuery(
    $machineName: String!
    $first: Int
    $after: String
    $groupIds: [ID]
  ) {
    service(machineName: $machineName) {
      _id
      pinnedDashboardPostsConnection: groupPostsConnection(
        first: null
        after: ""
        filterBy: { pinned: true, groupIds: $groupIds }
        orderBy: LASTMODIFIED_DESC
      ) @connection(key: "dashboardpinnedposts") {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...multiGroupsPostFragment
          }
        }
      }
    }
  }
`);

interface Props {
  groupIds: string[] | null;
  machineName: string;
}

export const ServiceMultiGroupPinnedPostsAccordion = ({
  machineName,
  groupIds,
}: Props) => {
  const [expanded, setExpanded] = useState(false);

  const { data, loading } = useQuery(SERVICE_GROUPS_PINNED_POSTS_QUERY, {
    variables: {
      machineName: machineName || '',
      first: POST_LIMIT,
      after: '',
      groupIds,
    },
    skip: !machineName,
    fetchPolicy: 'cache-and-network',
  });

  const service = data?.service;

  const posts =
    extractConnectionProps(service?.pinnedDashboardPostsConnection) || [];

  return (
    <>
      {posts.length > 0 && (
        <Or2Accordion
          onTop
          expanded={expanded}
          onChange={(e, ex) => {
            setExpanded(ex);
          }}
          slotProps={{
            transition: {
              unmountOnExit: true,
            },
          }}
          disabled={loading}
          whiteWhenDisabled
        >
          <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListSubheader sx={{ p: 0, backgroundColor: 'transparent' }}>
                {`Pinned posts (${posts.length})`}
              </ListSubheader>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <MultiGroupPinnedPostCollection
              loading={loading}
              posts={posts}
              machineName={machineName}
            />
          </AccordionDetails>
        </Or2Accordion>
      )}
    </>
  );
};
